// Prepare stylesheet
const styles = {
    eventAddressesSection: { marginTop: '30px' },
    mapView: { position: 'relative', height: '300px' },
};

export default styles;
